export const COLLECTION_META = [
  {
    "name": "Everyday Happiness",
    "types": "Totes, backpacks & clear stadium bags · bento boxes · decals, sticky notes & everyday tech",
    "slug": "everyday-happiness",
    "vibe": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours.",
    "bg": "bg-blush"
  },
  {
    "name": "Personal Growth",
    "types": "Journals & notebooks — spiral, softcover and hardcover",
    "slug": "personal-growth",
    "vibe": "Your life is worth getting excited about \u2014 consider these your everyday hype pieces.",
    "bg": "bg-lavender"
  },
  {
    "name": "Good Things",
    "types": "Tumblers, mugs & sipper glasses · golf balls · photo puzzles",
    "slug": "good-things",
    "vibe": "Good things aren't a fluke \u2014 they're becoming your normal.",
    "bg": "bg-sage/60"
  },
  {
    "name": "Presence",
    "types": "Blankets & comforters · night lights · posters, photo blocks & wall decor",
    "slug": "presence",
    "vibe": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space.",
    "bg": "bg-cream"
  },
  {
    "name": "Beach & Summer",
    "types": "Swimwear & beach bags · water bottles, tumblers & speakers · travel gear",
    "slug": "beach-summer",
    "vibe": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it.",
    "bg": "bg-blush"
  },
  {
    "name": "Wear Your Joy",
    "types": "Tees, tanks & hoodies · shorts, skorts & sweats · caps, pajamas & polos",
    "slug": "wear-your-joy",
    "vibe": "Made for the people who choose joy on purpose and aren't afraid to let it show.",
    "bg": "bg-lavender"
  },
  {
    "name": "Little Luxuries",
    "types": "Bracelets, necklaces & rings · jewelry boxes & makeup bags · flasks & gift wrap",
    "slug": "little-luxuries",
    "vibe": "Even the hard chapters can be shaped into something beautiful \u2014 quiet reminders, worn close and kept closer.",
    "bg": "bg-sage/60"
  }
];

export const PRODUCTS = [
  {
    "name": "Weekender Bag",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Beach & Summer",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This weekender bag packs a whole trip's worth of good vibes into one grab-and-go bag. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Suitcase",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Beach & Summer",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This suitcase packs a whole trip's worth of good vibes into one grab-and-go bag. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Spiral Notebook",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Personal Growth",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This spiral notebook gives your thoughts, goals, and 3am ideas somewhere good to go. Want to make it personal? Add a name or monogram to the cover. A Dream Freely Studios original from the Personal Growth collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or monogram to the cover"
  },
  {
    "name": "Women's Shorts",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This women's shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Distressed Cap",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This distressed cap tops off any outfit with an easy, everyday reminder stitched right in. Want to make it personal? Add embroidered name or initials. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": "Add embroidered name or initials"
  },
  {
    "name": "Cropped Hoodie",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This cropped hoodie layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Interval 3\" Short",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This interval 3\" short makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Garment-Dyed Muscle Tee",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This garment-dyed muscle tee layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Mesh Sneakers",
    "tagline": "Get Excited About Your Own Life",
    "collection": "Wear Your Joy",
    "desc": "Your life is worth getting excited about \u2014 this is your everyday hype piece. This mesh sneakers puts a little extra spring in your step, literally. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Kiss-Cut Vinyl Decal",
    "tagline": "Get Happy for Happy People",
    "collection": "Everyday Happiness",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This kiss-cut vinyl decal adds a little branded joy to everyday notes, gifts, and to-do lists. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Casual Shoulder Backpack",
    "tagline": "Get Happy for Happy People",
    "collection": "Everyday Happiness",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This casual shoulder backpack keeps daily essentials organized on commutes, campus days, or weekend errands. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Heart Cuff Bracelet",
    "tagline": "Get Happy for Happy People",
    "collection": "Little Luxuries",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This heart cuff bracelet sits on your wrist as a quiet, constant reminder of the message that matters most to you. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Fleece Crewneck Sweatshirt",
    "tagline": "Get Happy for Happy People",
    "collection": "Wear Your Joy",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This fleece crewneck sweatshirt layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Poly-Cotton Crop Tee",
    "tagline": "Get Happy for Happy People",
    "collection": "Wear Your Joy",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This poly-cotton crop tee layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Repeat Skort",
    "tagline": "Get Happy for Happy People",
    "collection": "Wear Your Joy",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This repeat skort makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Festival Tank",
    "tagline": "Get Happy for Happy People",
    "collection": "Wear Your Joy",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This festival tank layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Casual Shorts",
    "tagline": "Get Happy for Happy People",
    "collection": "Wear Your Joy",
    "desc": "Made for the people who choose joy on purpose and aren't afraid to let it show. This casual shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Bikini Swimsuit",
    "tagline": "Get Joy Where You Find It",
    "collection": "Beach & Summer",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This bikini swimsuit makes beach days and pool days feel like the good things they are. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Woven Straw Tote Bag",
    "tagline": "Get Joy Where You Find It",
    "collection": "Beach & Summer",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This woven straw tote bag carries everything from groceries to gym gear without ever feeling like 'just' a bag. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Swim Trunks",
    "tagline": "Get Joy Where You Find It",
    "collection": "Beach & Summer",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This swim trunks makes beach days and pool days feel like the good things they are. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Golf Balls, Set of 6",
    "tagline": "Get Joy Where You Find It",
    "collection": "Good Things",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This golf balls, set of 6 adds a little Dream Freely energy to time outside, wherever that takes you. A Dream Freely Studios original from the Good Things collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Sipper Glass with Straw",
    "tagline": "Get Joy Where You Find It",
    "collection": "Good Things",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This sipper glass with straw keeps your coffee, wine, or iced tea at the right temperature, exactly when you need the reminder. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Good Things collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Chill Wine Tumbler",
    "tagline": "Get Joy Where You Find It",
    "collection": "Good Things",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This chill wine tumbler keeps your coffee, wine, or iced tea at the right temperature, exactly when you need the reminder. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Good Things collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Leather Bracelet with Beads",
    "tagline": "Get Joy Where You Find It",
    "collection": "Little Luxuries",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This leather bracelet with beads sits on your wrist as a quiet, constant reminder of the message that matters most to you. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Crop Top",
    "tagline": "Get Joy Where You Find It",
    "collection": "Wear Your Joy",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This crop top layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Relaxed Fine Jersey Tank",
    "tagline": "Get Joy Where You Find It",
    "collection": "Wear Your Joy",
    "desc": "Joy doesn't wait for perfect circumstances \u2014 it shows up in small, ordinary moments, if you let it. This relaxed fine jersey tank layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Duffel Bag",
    "tagline": "Get Out of Your Own Way",
    "collection": "Beach & Summer",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This duffel bag packs a whole trip's worth of good vibes into one grab-and-go bag. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Mobile Display Stand",
    "tagline": "Get Out of Your Own Way",
    "collection": "Everyday Happiness",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This mobile display stand keeps you charged, connected, or heard, with a message built right in. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Softcover Journal",
    "tagline": "Get Out of Your Own Way",
    "collection": "Personal Growth",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This softcover journal gives your thoughts, goals, and 3am ideas somewhere good to go. Want to make it personal? Add a name or monogram to the cover. A Dream Freely Studios original from the Personal Growth collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or monogram to the cover"
  },
  {
    "name": "Hardcover Journal",
    "tagline": "Get Out of Your Own Way",
    "collection": "Personal Growth",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This hardcover journal gives your thoughts, goals, and 3am ideas somewhere good to go. Want to make it personal? Add a name or monogram to the cover. A Dream Freely Studios original from the Personal Growth collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or monogram to the cover"
  },
  {
    "name": "Women's Biker Shorts",
    "tagline": "Get Out of Your Own Way",
    "collection": "Wear Your Joy",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This women's biker shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Polyester Yoga Shorts",
    "tagline": "Get Out of Your Own Way",
    "collection": "Wear Your Joy",
    "desc": "The only thing between you and good things is sometimes just you \u2014 consider this your gentle nudge. This polyester yoga shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Slim Water Bottle",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Beach & Summer",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This slim water bottle keeps you hydrated with a design you'll actually want to carry around. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Beach Holographic Tote Bag",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Beach & Summer",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This beach holographic tote bag carries everything from groceries to gym gear without ever feeling like 'just' a bag. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Photo Puzzle",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Good Things",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This photo puzzle adds a little Dream Freely energy to time outside, wherever that takes you. A Dream Freely Studios original from the Good Things collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Heart-Shaped Mug",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Good Things",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This heart-shaped mug turns morning coffee into a two-minute pep talk. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Good Things collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Stainless Steel Flask",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Little Luxuries",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This stainless steel flask keeps your coffee, wine, or iced tea at the right temperature, exactly when you need the reminder. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Paperclip Heart Bracelet",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Little Luxuries",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This paperclip heart bracelet sits on your wrist as a quiet, constant reminder of the message that matters most to you. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Holographic Makeup Bag",
    "tagline": "Get Used to Good Things Happening",
    "collection": "Little Luxuries",
    "desc": "A gentle reminder that good things aren't a fluke \u2014 they're becoming your normal. This holographic makeup bag keeps your everyday essentials together and looking good doing it. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Natural Stone Stretch Bracelet",
    "tagline": "Make Peace With What Is",
    "collection": "Little Luxuries",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This natural stone stretch bracelet sits on your wrist as a quiet, constant reminder of the message that matters most to you. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Crushed Velvet Blanket",
    "tagline": "Make Peace With What Is",
    "collection": "Presence",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This crushed velvet blanket turns any couch or bed into the softest place to land at the end of the day. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Fleece Sherpa Blanket",
    "tagline": "Make Peace With What Is",
    "collection": "Presence",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This fleece sherpa blanket turns any couch or bed into the softest place to land at the end of the day. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Comforter",
    "tagline": "Make Peace With What Is",
    "collection": "Presence",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This comforter turns any couch or bed into the softest place to land at the end of the day. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Custom Shape Night Light",
    "tagline": "Make Peace With What Is",
    "collection": "Presence",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This custom shape night light makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Cuffed Beanie",
    "tagline": "Make Peace With What Is",
    "collection": "Wear Your Joy",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This cuffed beanie tops off any outfit with an easy, everyday reminder stitched right in. Want to make it personal? Add embroidered name or initials. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": "Add embroidered name or initials"
  },
  {
    "name": "Full-Zip Hooded Sweatshirt",
    "tagline": "Make Peace With What Is",
    "collection": "Wear Your Joy",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This full-zip hooded sweatshirt layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Fleece Sweatpants",
    "tagline": "Make Peace With What Is",
    "collection": "Wear Your Joy",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This fleece sweatpants makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Flannel Shorts",
    "tagline": "Make Peace With What Is",
    "collection": "Wear Your Joy",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This flannel shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Satin Pajama Set",
    "tagline": "Make Peace With What Is",
    "collection": "Wear Your Joy",
    "desc": "Not everything needs fixing today. Some days, peace is the whole point. This satin pajama set turns bedtime into a little ritual instead of just the end of the day. Want to make it personal? Add name or initials to sleeve. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name or initials to sleeve"
  },
  {
    "name": "Sticky Note Pad",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This sticky note pad adds a little branded joy to everyday notes, gifts, and to-do lists. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Clear Backpack",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This clear backpack keeps daily essentials organized on commutes, campus days, or weekend errands. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Magnetic Power Bank",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This magnetic power bank keeps you charged, connected, or heard, with a message built right in. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Bento Lunch Box",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This bento lunch box makes meal prep and lunch packing feel just a little more put-together. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Glass Cutting Board",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This glass cutting board makes meal prep and lunch packing feel just a little more put-together. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Diaper Backpack",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This diaper backpack keeps daily essentials organized on commutes, campus days, or weekend errands. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Foldable Umbrella",
    "tagline": "Make Room for Good Things",
    "collection": "Everyday Happiness",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This foldable umbrella adds a little Dream Freely energy to time outside, wherever that takes you. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Jewelry Travel Case",
    "tagline": "Make Room for Good Things",
    "collection": "Little Luxuries",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This jewelry travel case keeps every ring, chain, and bracelet organized and tangle-free at home or on the go. Want to make it personal? Add a monogram to the lid. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a monogram to the lid"
  },
  {
    "name": "French Terry Shorts",
    "tagline": "Make Room for Good Things",
    "collection": "Wear Your Joy",
    "desc": "When you clear space, physically and mentally, good things finally have somewhere to land. This french terry shorts makes lounging, working out, or running errands feel a little more like self-care. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Blush & Bloom Gift Set",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This blush & bloom gift set arrives ready to give \u2014 no extra wrapping, no extra thinking, just good things in a box. Want to make it personal? Add a gift note. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a gift note"
  },
  {
    "name": "Wrapping Paper",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This wrapping paper adds a little branded joy to everyday notes, gifts, and to-do lists. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Charcuterie Board",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This charcuterie board makes meal prep and lunch packing feel just a little more put-together. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Heart Necklace",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This heart necklace keeps the message close, right where you can see it (or feel it) all day. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Double Zipper Jewelry Box",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This double zipper jewelry box keeps every ring, chain, and bracelet organized and tangle-free at home or on the go. Want to make it personal? Add a monogram to the lid. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a monogram to the lid"
  },
  {
    "name": "Gift Wrapping Paper Sheet",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This gift wrapping paper sheet adds a little branded joy to everyday notes, gifts, and to-do lists. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Makeup Bag",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Little Luxuries",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This makeup bag keeps your everyday essentials together and looking good doing it. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Colored Frame Poster",
    "tagline": "Make Something Beautiful Out of It",
    "collection": "Presence",
    "desc": "Even the hard chapters can be shaped into something beautiful \u2014 that's the whole Dream Freely philosophy. This colored frame poster makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Sunsplash Tumbler with Straw",
    "tagline": "Make Today Amazing",
    "collection": "Beach & Summer",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This sunsplash tumbler with straw keeps your coffee, wine, or iced tea at the right temperature, exactly when you need the reminder. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Mini Water Bottle",
    "tagline": "Make Today Amazing",
    "collection": "Beach & Summer",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This mini water bottle keeps you hydrated with a design you'll actually want to carry around. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Outdoor Bluetooth Speaker",
    "tagline": "Make Today Amazing",
    "collection": "Beach & Summer",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This outdoor bluetooth speaker keeps you charged, connected, or heard, with a message built right in. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Car Sun Shade",
    "tagline": "Make Today Amazing",
    "collection": "Beach & Summer",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This car sun shade adds a little Dream Freely energy to time outside, wherever that takes you. A Dream Freely Studios original from the Beach & Summer collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Bento Box with Utensils",
    "tagline": "Make Today Amazing",
    "collection": "Everyday Happiness",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This bento box with utensils makes meal prep and lunch packing feel just a little more put-together. Want to make it personal? Add a name or initials. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or initials"
  },
  {
    "name": "Canvas Tote Bag",
    "tagline": "Make Today Amazing",
    "collection": "Everyday Happiness",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This canvas tote bag carries everything from groceries to gym gear without ever feeling like 'just' a bag. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Clear Stadium Tote",
    "tagline": "Make Today Amazing",
    "collection": "Everyday Happiness",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This clear stadium tote carries everything from groceries to gym gear without ever feeling like 'just' a bag. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Transparent Fanny Pack",
    "tagline": "Make Today Amazing",
    "collection": "Everyday Happiness",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This transparent fanny pack packs a whole trip's worth of good vibes into one grab-and-go bag. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Clear Stadium Backpack",
    "tagline": "Make Today Amazing",
    "collection": "Everyday Happiness",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This clear stadium backpack keeps daily essentials organized on commutes, campus days, or weekend errands. A Dream Freely Studios original from the Everyday Happiness collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Classic Dad Cap",
    "tagline": "Make Today Amazing",
    "collection": "Wear Your Joy",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This classic dad cap tops off any outfit with an easy, everyday reminder stitched right in. Want to make it personal? Add embroidered name or initials. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": "Add embroidered name or initials"
  },
  {
    "name": "Core Cotton Tank Top",
    "tagline": "Make Today Amazing",
    "collection": "Wear Your Joy",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This core cotton tank top layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Dri-Mesh V-Neck Polo",
    "tagline": "Make Today Amazing",
    "collection": "Wear Your Joy",
    "desc": "A daily nudge that today doesn't have to be perfect to be amazing \u2014 it just has to be yours. This dri-mesh v-neck polo layers into your everyday wardrobe as a soft, walking reminder of the message you needed today. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": ""
  },
  {
    "name": "Bangle Cuff Bracelet",
    "tagline": "Make Your Presence Count",
    "collection": "Little Luxuries",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This bangle cuff bracelet sits on your wrist as a quiet, constant reminder of the message that matters most to you. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Heart Signet Ring",
    "tagline": "Make Your Presence Count",
    "collection": "Little Luxuries",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This heart signet ring wraps a daily affirmation around your finger \u2014 small, but impossible to forget. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Paperclip Heart Necklace",
    "tagline": "Make Your Presence Count",
    "collection": "Little Luxuries",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This paperclip heart necklace keeps the message close, right where you can see it (or feel it) all day. Want to make it personal? Add name, date, or short quote engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add name, date, or short quote engraving"
  },
  {
    "name": "Cufflinks",
    "tagline": "Make Your Presence Count",
    "collection": "Little Luxuries",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This cufflinks adds a personal, thoughtful detail to the days that call for a little more polish. Want to make it personal? Add initials or a short engraving. A Dream Freely Studios original from the Little Luxuries collection \u2014 because good things are allowed to happen.",
    "personalization": "Add initials or a short engraving"
  },
  {
    "name": "Photo Block",
    "tagline": "Make Your Presence Count",
    "collection": "Presence",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This photo block makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Free-Standing Wooden Decor",
    "tagline": "Make Your Presence Count",
    "collection": "Presence",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This free-standing wooden decor makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Custom Cut Statue",
    "tagline": "Make Your Presence Count",
    "collection": "Presence",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This custom cut statue makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Wall Decal Set",
    "tagline": "Make Your Presence Count",
    "collection": "Presence",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This wall decal set makes the message part of the room, not just something you read once and forget. Want to make it personal? Add a name or custom photo. A Dream Freely Studios original from the Presence collection \u2014 because good things are allowed to happen.",
    "personalization": "Add a name or custom photo"
  },
  {
    "name": "Necktie",
    "tagline": "Make Your Presence Count",
    "collection": "Wear Your Joy",
    "desc": "You don't have to shrink to fit into a room \u2014 your presence is allowed to take up space. This necktie adds a quietly encouraging detail to the days that call for a little polish. Want to make it personal? Add embroidered initials. A Dream Freely Studios original from the Wear Your Joy collection \u2014 because good things are allowed to happen.",
    "personalization": "Add embroidered initials"
  }
];
